import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { ChargeDetailModel } from "presentation/model/ChargeDetailMaintenance/ChargeDetailModel";
import DateTimePickerComponent from "presentation/view/components/DateTimePickerComponent";

export const FromToDateAccordion = ({ chargeDetailState }: { chargeDetailState: ChargeDetailModel }) => {
    const chargeBatchUpdate = chargeDetailState.chargeBatchUpdate
    const chargeDetailVM = useChargeDetailVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item' style={{ width: "240px" }}>
                    <DateTimePickerComponent
                        label='From Date'
                        width='240px'
                        date={chargeBatchUpdate.fromDate}
                        onDateChange={chargeDetailVM.onDatePickerChange}
                        fieldName={"fromDate"} />
                </div>
            </div>

            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item' style={{ width: "240px" }}>
                    <DateTimePickerComponent
                        label='To Date'
                        width='240px'
                        date={chargeBatchUpdate.toDate}
                        onDateChange={chargeDetailVM.onDatePickerChange}
                        fieldName={"toDate"} />
                </div>
            </div>
        </>
    )
}